import { EnvelopeSimpleIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { buttonClasses } from '~/ui/Button.js';
import { Section } from '~/ui/Section.js';

/**
 * The address a player writes to. The Terms and the Privacy Policy name the
 * same one (`backend/config/legal/`); Mitch confirmed it on 2026-10-01.
 */
export const SUPPORT_EMAIL = 'support@cribbageace.com';

/**
 * Help and support: the ghost chip under the settings doors opens this.
 *
 * Drawn to the `lobby-settings` sketch's support page and
 * `docs/ux/account/settings.md`. Email is the one channel, so the page is one
 * line that names the address and one button that opens the player's mail app.
 * The address is written out too, for a device with no mail app set up.
 */
export function SupportPage(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <Section title={t('settings.support.contact')}>
      <p className="mb-4 text-ink">{t('settings.support.intro', { email: SUPPORT_EMAIL })}</p>
      <a href={`mailto:${SUPPORT_EMAIL}`} className={buttonClasses('default', 'md', 'self-start')}>
        <EnvelopeSimpleIcon size={18} aria-hidden="true" focusable="false" />
        {t('settings.support.email')}
      </a>
    </Section>
  );
}
